define('adminUserGroupsEditPopupView',[
  'app',
  'module',
  'backbone',
  'underscore',
  'jquery',
  'marionette',
  'bootbox',
  'template!adminUserGroupsEditPopupView',
  'entities/admin/user_groups'
], function (
  App,
  Module,
  Backbone,
  _,
  $,
  Marionette,
  Bootbox,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'admin-user-groups-popup-edit-view',

    ui: {
      searchInput: '.search-input',
      suggestions: '.suggestions',
      membersList: '.members-list',
      closeButton: '.btn-close'
    },

    events: {
      'input @ui.searchInput': 'onSearch',
      'click .suggestion': 'onPickSuggestion',
      'click .members-list .remove': 'onRemoveMember',
      'change .hide-from-tagging-input': 'onToggleHideFromTagging',
      'change .group-flag-input': 'onToggleFlag',
      'click @ui.closeButton': 'onClose'
    },

    initialize: function () {
      this.groupSecId = this.options.groupSecId;
      this.canEdit = this.options.canEdit === true;
      this.group = null;
      this.searchTimer = null;
    },

    onShow: function () {
      this.loadGroup();
    },

    loadGroup: function () {
      App.request('userGroups:get', this.groupSecId).done(_.bind(function (data) {
        this.group = data;
        this.render();
      }, this));
    },

    serializeData: function () {
      return {
        canEdit: this.canEdit,
        name: this.group ? this.group.name : '',
        members: this.group && this.group.members ? this.group.members : [],
        hideFromTagging: !!(this.group && this.group.hideFromTagging),
        visibleInCalendar: !!(this.group && this.group.visibleInCalendar),
        placeholder: _.i18n('admin.userGroups.searchMemberPlaceholder')
      };
    },

    // Persist immediately — the popup has no save button; revert the
    // checkbox when the update fails so the UI never lies.
    onToggleHideFromTagging: function (e) {
      this.toggleFlag(e, 'hideFromTagging');
    },

    /** Generic boolean group setting; the checkbox names the flag in data-flag. */
    onToggleFlag: function (e) {
      this.toggleFlag(e, $(e.currentTarget).data('flag'));
    },

    toggleFlag: function (e, flag) {
      var checked = $(e.currentTarget).is(':checked');
      var self = this;
      var body = {};
      body[flag] = checked;
      App.request('userGroups:update', this.groupSecId, body)
        .done(function (data) {
          if (self.isDestroyed) { return; }
          self.group = data;
        })
        .fail(function () {
          if (self.isDestroyed) { return; }
          $(e.currentTarget).prop('checked', !checked);
        });
    },

    onSearch: function () {
      if (!this.canEdit) return;
      var query = this.ui.searchInput.val();
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      }
      this.searchTimer = setTimeout(_.bind(function () {
        if (!query || query.length < 1) {
          this.ui.suggestions.empty().hide();
          return;
        }
        App.request('userGroups:search-userpids', query).done(_.bind(function (users) {
          this.renderSuggestions(users || []);
        }, this));
      }, this), 250);
    },

    renderSuggestions: function (users) {
      var currentIds = _.pluck((this.group && this.group.members) || [], 'secId');
      var filtered = _.filter(users, function (u) {
        return !_.contains(currentIds, u.secId);
      });
      var html = _.map(filtered, function (u) {
        var label = _.escape((u.firstName || '') + ' ' + (u.lastName || '') + ' <' + (u.email || '') + '>');
        return '<div class="suggestion" data-sec-id="' + _.escape(u.secId) + '">' + label + '</div>';
      }).join('');
      this.ui.suggestions.html(html).show();
    },

    onPickSuggestion: function (e) {
      if (!this.canEdit) return;
      var secId = $(e.currentTarget).data('sec-id');
      App.request('userGroups:add-member', this.groupSecId, secId).done(_.bind(function () {
        this.ui.searchInput.val('');
        this.ui.suggestions.empty().hide();
        this.loadGroup();
        if (this.options.onConfirm) this.options.onConfirm();
      }, this)).fail(function (xhr) {
        var msg = (xhr && xhr.status === 403) ?
          _.i18n('admin.userGroups.forbidden') :
          _.i18n('common.error');
        Bootbox.alert(msg);
      });
    },

    onRemoveMember: function (e) {
      if (!this.canEdit) return;
      var secId = $(e.currentTarget).data('sec-id');
      App.request('userGroups:remove-member', this.groupSecId, secId).done(_.bind(function () {
        this.loadGroup();
        if (this.options.onConfirm) this.options.onConfirm();
      }, this)).fail(function (xhr) {
        var msg = (xhr && xhr.status === 403) ?
          _.i18n('admin.userGroups.forbidden') :
          _.i18n('common.error');
        Bootbox.alert(msg);
      });
    },

    onClose: function () {
      this.windowView.close();
    }
  });
});

